import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ROUTES } from './routes'

export const AppRoutes = (): JSX.Element => (
  <RouterProvider router={createBrowserRouter(ROUTES)} />
)
